import { render, staticRenderFns } from "./Actualites.vue?vue&type=template&id=5ad649fa"
import script from "./Actualites.vue?vue&type=script&lang=js"
export * from "./Actualites.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports